import React, { useEffect } from 'react';
import { View } from 'native-base';

import { theme } from '@breakroom-nx/assets';
import { AppInfo } from '@breakroom-nx/ui';

// Platform Specific Components
import Globe from '../globe/globe';
import PanelWrapper, { PanelType } from '../panel-wrapper/panel-wrapper';
import FeedbackWrapper from '../feedback-wrapper/feedback-wrapper';
import TabNavigationContainer from '../tab-navigation-container/tab-navigation-container';

// Redux
import { useAppDispatch, setDevice } from '@breakroom-nx/redux';

function Home() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleResize = () => {
      dispatch(setDevice(window.innerWidth <= 768));
    };

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [dispatch]);

  useEffect(() => {
    // console.log(`Rendering Home Page`);
  });

  return (
    <View
      height={'full'}
      width={'full'}
      bg={theme.colors.surface[100]}
      style={{
        justifyContent: 'flex-end',
        overflow: 'hidden',
      }}
    >
      <Globe generateRandomData={false} mobile={false} />
      <AppInfo />
      <FeedbackWrapper />
      <PanelWrapper type={PanelType.Chat} />
      <PanelWrapper type={PanelType.Profile} />
      <PanelWrapper type={PanelType.OtherUserProfile} />
      <TabNavigationContainer />
    </View>
  );
}

export default React.memo(Home);
